import type {
  CartBundleDto,
  CartDto,
  CartPromotionDto,
  CartSkuDto,
  CartSubscriptionDto,
} from './schemas'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema, Identifier } from '../../shared/types'
import {
  AddPromotionToCartBodySchema,
  CreateCartBodySchema,
  CreateCartBundleBodySchema,
  CreateCartSubscriptionBodySchema,
  LatestCartDtoSchema,
  UpsertCartSkuBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/carts',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    409: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const cartCartsContract = c.router({
  createCart: {
    method: 'POST',
    path: '',
    body: CreateCartBodySchema,
    responses: {
      201: c.type<CartDto>(),
    },
  },

  getLatestCart: {
    method: 'GET',
    path: '/latest',
    query: z.object({
      userId: Identifier,
    }),
    responses: {
      200: LatestCartDtoSchema,
    },
  },

  getCart: {
    method: 'GET',
    path: '/:cartId',
    pathParams: z.object({
      cartId: Identifier,
    }),
    responses: {
      200: c.type<CartDto>(),
    },
  },

  deleteCart: {
    method: 'DELETE',
    path: '/:cartId',
    pathParams: z.object({
      cartId: Identifier,
    }),
    responses: {
      204: c.type<null>(),
    },
  },

  upsertSkuToCart: {
    method: 'PUT',
    path: '/:cartId/skus/:productVariantId',
    pathParams: z.object({
      cartId: Identifier,
      productVariantId: Identifier,
    }),
    body: UpsertCartSkuBodySchema,
    responses: {
      200: c.type<CartSkuDto>(),
    },
  },

  deleteSkuFromCart: {
    method: 'DELETE',
    path: '/:cartId/skus/:productVariantId',
    pathParams: z.object({
      cartId: Identifier,
      productVariantId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },

  createCartBundle: {
    method: 'POST',
    path: '/:cartId/bundles',
    pathParams: z.object({
      cartId: Identifier,
    }),
    body: CreateCartBundleBodySchema,
    responses: {
      201: c.type<CartBundleDto>(),
    },
  },

  createCartSubscription: {
    method: 'POST',
    path: '/:cartId/subscriptions',
    pathParams: z.object({
      cartId: Identifier,
    }),
    body: CreateCartSubscriptionBodySchema,
    responses: {
      201: c.type<CartSubscriptionDto>(),
    },
  },

  addPromotionToCart: {
    method: 'POST',
    path: '/:cartId/promotions/:promotionId',
    pathParams: z.object({
      cartId: Identifier,
      promotionId: Identifier,
    }),
    body: AddPromotionToCartBodySchema,
    responses: {
      201: c.type<CartPromotionDto>(),
    },
  },

  deletePromotionFromCart: {
    method: 'DELETE',
    path: '/:cartId/promotions/:promotionId',
    pathParams: z.object({
      cartId: Identifier,
      promotionId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },
}, options)
